/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderOrderStatus = "CANCELED" | "EXECUTED" | "PARTIALLY_CANCELED" | "PARTIALLY_COMPLETED" | "PENDING" | "%future added value";
export type CheckOrderStatusQueryVariables = {|
  id?: ?string
|};
export type CheckOrderStatusQueryResponse = {|
  +allOrders: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +orderStatus: OrderOrderStatus
      |}
    |}>
  |}
|};
export type CheckOrderStatusQuery = {|
  variables: CheckOrderStatusQueryVariables,
  response: CheckOrderStatusQueryResponse,
|};
*/


/*
query CheckOrderStatusQuery(
  $id: ID
) {
  allOrders(id: $id) {
    edges {
      node {
        orderStatus
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderStatus",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckOrderStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OrderNodeConnection",
        "kind": "LinkedField",
        "name": "allOrders",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrderNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CheckOrderStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OrderNodeConnection",
        "kind": "LinkedField",
        "name": "allOrders",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrderNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5f1d102f505ac7c0517c0f45f6865952",
    "id": null,
    "metadata": {},
    "name": "CheckOrderStatusQuery",
    "operationKind": "query",
    "text": "query CheckOrderStatusQuery(\n  $id: ID\n) {\n  allOrders(id: $id) {\n    edges {\n      node {\n        orderStatus\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd7c0aca43f973e854b76fcd1cde5ee80';

module.exports = node;
